export {default} from './VerifyAddressSuccess';
